/*=========================================================================================
  File Name: moduleDataList.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import state from './moduleRoleState.js'
// import mutations from './moduleRoleMutations.js'
import actions from "./moduleRoleActions.js";
// import getters from './moduleRoleGetters.js'

export default {
	isRegistered: false,
	namespaced: true,
	state: {
		roles: [],
		permissions: [],
		rolepermission: [],
	},
	mutations: {
		ADD_ITEM(state, item) {
			state.roles = item;
		},
		SET_PERMISSIONS(state, payload) {
			state.permissions = payload;
		},
		SET_ROLE_PERMISSIONS(state, payload) {
			state.rolepermission = payload;
		},
	},
	actions,
	// getters
};
